const API_URL = process.env.REACT_APP_API_BASE_URL || '';
export const API_TOKEN = process.env.REACT_APP_API_TOKEN;
export const VITE_AZURE_CLIENTID = process.env.REACT_APP_VITE_AZURE_CLIENTID;
export const VITE_AZURE_AUTHORITY = process.env.REACT_APP_VITE_AZURE_AUTHORITY;
export const DEPLOYED_APP_URL = process.env.REACT_APP_DEPLOYED_APP_URL || '';



export const API_ENDPOINTS = 
{ 
    license_status :(state, pan) => `/distributors?tax_number=${pan}&state_code=${state}`,
    license_submission: (sapids) => `/distributors/license-documents?sap_ids=${sapids}`
}


export const get = async (endpoint, params) => {
  const url = new URL(`${API_URL}${endpoint}`);
  if (params) {
    Object.entries(params).forEach(([key, value]) =>
      url.searchParams.append(key, value)
    );
  }

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": API_TOKEN,
      // "X-User-Id": 'P123456'
    } 
    })

  if (response.ok) {
    if (response.status === 204) {
      console.log("No content returned from the server.");
      return null;
    } else if (response.status === 200) {
      const contentType = response.headers.get("content-type");
      if (contentType && !contentType.includes("application/json")) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        const contentDisposition = response.headers.get("Content-Disposition");
        let fileName = "download.csv";
        if (contentDisposition && contentDisposition.includes("filename=")) {
          fileName = contentDisposition.split("filename=")[1].split(";")[0].trim().replace(/"/g, "");
        }
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        return;
      }
      const data = await response.json();
      return data;
    } else {
      const errorText = await response.text();
      throw new Error(`HTTP error ${response.status}: ${errorText}`);
    }
  } else {
    
    const errorText = await response.text();
    throw new Error(`HTTP error ${response.status}: ${errorText}`);
  }
};

export const post = async (endpoint, data) => {
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": API_TOKEN,
    },
    body:JSON.stringify(data),
  });

  const responseData = await response.json();

  if (response.ok) {
    console.log("REQUEST FINE");
    return responseData;
  } else {
    if (
      responseData.message === "Failed to create retailer" &&
      response.status === 500
    ) {
      window.alert(
        "A survey is already under progress/completed for this user, please contact your Admin for more info"
      );
      return;
    } else if (response.status === 409) {
      return { ...responseData, status: response.status };
    } else {
      window.alert("Something went Wrong!");
      return;
    }
  }
};


export const put = async (endpoint, data) => {
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": API_TOKEN,
    },
    body:JSON.stringify(data),
  });

  const responseData = await response.json();

  if (response.ok) {
    console.log("REQUEST FINE");
    return responseData;
  } else {
    if (
      responseData.message === "Failed to create retailer" &&
      response.status === 500
    ) {
      window.alert(
        "A survey is already under progress/completed for this user, please contact your Admin for more info"
      );
      return;
    } else if (response.status === 409) {
      return { ...responseData, status: response.status };
    } else {
      window.alert("Something went Wrong!");
      return;
    }
  }
};
